import styled from 'styled-components';

export const StyledQuestionPage = styled.div`
    background: var(--background-page);
    min-height: 100vh;
`;

export const QuestionPageWrapper = styled.main`
    position: relative;
    max-width: var(--page-width-l);
    margin: 0px auto;
    padding: var(--header-height) 20px 40px;
    max-width: 960px;

    @media (max-width: 640px) {
        padding: var(--header-height) 10px 40px;
    }
`;

export const StatisticSectionQuestionNumber = styled.div`
    font-size: 15px;
`;

export const StatisticSectionQuestionsLeft = styled.div`
    font-size: 15px;
    display: flex;
    gap: 5px;

    div {
        background: #00000012;
        font-size: 14px;
        display: flex;
        align-items: center;
        padding: 0px 8px;
        height: 100%;
        border-radius: 30px;
    }
`;

export const QuestionSection = styled.section<{ isLoading?: boolean }>`
    background: var(--white);
    border: 1px solid #dddddd;
    border-radius: 15px;
    margin: 30px 0px 15px;
    padding: 20px 25px;
`;

export const QuestionSectionTitle = styled.div`
    h1 {
        font-family: var(--font-700);
        font-size: 1.8em;
        margin: 20px 0px 0px;
    }

    @media (max-width: 640px) {
        h1 {
            font-size: 1.2em;
        }
    }
`;

export const QuestionStatistic = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const AnswerSection = styled.section`
    position: relative;
    background: var(--white);
    border: 1px solid #dddddd;
    border-radius: 15px;
    margin: 0px 0px 20px;
    padding: 10px 25px 20px;
    overflow: hidden;
`;

export const AnswerSectionTitle = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    min-height: 40px;

    h2 {
        font-size: 18px;
        margin-left: 15px;
    }

    @media (max-width: 640px) {
        h2 {
            display: none;
        }
    }
`;

export const AnswerSectionSolution = styled.div`
    --font-size-base: 18px;
    --line-height-base: calc(var(--font-size-base) * 1.5);

    opacity: 0;
    animation: fadeInAnimation 0.5s forwards;
    width: 100%;

    @keyframes fadeInAnimation {
        to {
            opacity: 1;
            padding-bottom: 20px;
        }
    }

    img {
        max-width: 100%;
    }

    ul,
    ol {
        position: relative;
        list-style-type: none;
        max-width: var(--guide-content-width);
        box-sizing: border-box;
        margin: 0px auto 16px;

        li {
            text-align: justify;

            font-size: var(--font-size-base);
            line-height: var(--line-height-base);

            &:not(:last-child) {
                margin-bottom: var(--indent-s);
            }

            &::before {
                position: absolute;
                margin-left: -20px;
                margin-top: 0.5em;
                content: '';
                border-radius: 50%;
                border: 3px solid var(--primary-blue);
                padding: 2px 2px;
            }
        }
    }

    h1,
    h2,
    h3,
    h4 {
        font-family: var(--font-700);
        color: inherit;
        max-width: var(--guide-content-width);
        margin: 0 auto 16px auto;
    }

    h2,
    h3,
    h4 {
        margin: 24px auto 12px;
    }

    h1 {
        font-size: calc(var(--font-size-base) * 1.3);
    }

    h2 {
        font-size: calc(var(--font-size-base) * 1.15);
    }

    h3 {
        font-size: calc(var(--font-size-base) * 1.05);
    }

    p,
    blockquote {
        text-align: justify;
        max-width: var(--guide-content-width);
        box-sizing: border-box;
        margin: 16px auto;
    }

    p {
        font-size: var(--font-size-base);
        line-height: var(--line-height-base);
    }

    blockquote {
        padding: var(--indent-m) var(--indent-xl);

        text-align: justify;
        background: var(--background-page);
        border-radius: var(--border-radius-m);
        position: relative;
        overflow: auto;

        &::before {
            content: '';

            position: absolute;
            display: block;
            width: 3px;
            background-color: var(--primary-blue);
            bottom: 0;
            top: 0;
            left: 0;
        }

        p:last-child,
        p:first-child {
            margin: 0 auto;
        }
    }

    pre {
        max-width: var(--guide-content-width);
        margin: 22px auto;

        font-size: var(--font-size-base);
        line-height: var(--line-height-base);
    }

    .bold {
        font-weight: 500;
    }

    a {
        text-decoration: none;

        &:hover {
            border-bottom: 1px solid;
            margin-bottom: -1px;
        }
    }

    .guide-basic-table {
        border-spacing: 0;
        border: 1px solid rgb(210, 210, 210);
        border-radius: var(--border-radius-m);

        overflow: hidden;
        width: 100%;
        max-width: var(--guide-content-width);
        margin: 22px auto;

        background: rgb(250, 250, 250);

        font-size: var(--font-size-base);
        line-height: var(--line-height-base);

        tr {
            th {
                padding: var(--indent-s) var(--indent-m);
                font-weight: 400;
                border: 1px solid var(--light-grey);
                border-top: none;
                border-left: none;
                white-space: nowrap;
                background: #f0f0f0;

                &:last-child {
                    padding-left: 15px;
                    border-right: none;
                }
            }
        }

        tbody {
            tr {
                border: 1px solid var(--light-grey);

                td {
                    padding: var(--indent-m);
                    border: 1px solid var(--light-grey);
                    border-top: none;
                    border-left: none;

                    &:last-child {
                        border-right: none;
                    }
                }

                td:last-of-type {
                    padding-left: 15px;
                }

                &:last-child td {
                    border-bottom: none;
                }
            }
        }
    }

    .guide-erd {
        position: relative;
        height: 400px;
        background: var(--database-diagram-background);
        margin: 25px 0px;
        border-radius: var(--border-radius-m);
        border: 1px solid var(--background-page);

        .loader {
            height: 100%;
        }
    }

    .guide-img {
        width: 100%;
        height: auto;
        border-radius: var(--border-radius-m);
    }

    .guide-quiz {
        font-size: calc(var(--font-size-base) * 0.9);
        line-height: calc(var(--line-height-base) * 0.9);
    }
`;

export const AnswerSectionSolutionHider = styled.div<{ isOpenSolution?: boolean }>`
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    align-items: start;
    justify-content: center;
    min-height: 250px;
    background: var(--white);

    ${({ isOpenSolution }) => `
        display: ${isOpenSolution ? 'none' : 'flex'}
    `}
`;

export const ActionButtonShortcut = styled.div<{ isPressed?: boolean }>`
    justify-content: center;
    display: flex;
    width: 35px;
    height: 35px;
    background: #fff;
    border: 1px solid #b4b4b4;
    border-radius: 10px;
    align-items: center;
    color: #b4b4b4;
    transition: 0.2s ease;

    ${({ isPressed }) =>
        isPressed &&
        `
        border: 1px solid var(--primary-blue);
        color: var(--primary-blue);
        background: #ededed;
        box-shadow: var(--shadow-xs);
    `}

    @media (max-width: 640px) {
        display: none;
    }
`;

export const ActionsSection = styled.section`
    display: flex;
    justify-content: space-between;
    margin-bottom: 25px;
`;

export const ActionButton = styled.button`
    display: flex;
    gap: 15px;
    align-items: center;
    border: 1px solid #dddddd;
    cursor: pointer;
    padding: 10px 15px;
    border-radius: 15px;
    font-size: 16px;
    background: var(--white);
    font-family: var(--font-500);
    color: var(--text-color-primary);
    min-width: 240px;
    min-height: 50px;
    transition: 0.2s ease;

    &:hover {
        background: #dddddd;
    }

    @media (max-width: 640px) {
        min-width: 190px;
    }
`;
